import React from "react";
import styled from "styled-components"

const Styled={
    Wrap:styled.div`
        width:100%;
        height:50px;
    `,
}

const TopNot=()=>{
    return(
        <Styled.Wrap></Styled.Wrap>
    )
}
export default TopNot